import Vue from 'vue';
import Vuex from 'vuex';
import { AppModule } from './modules/app';
import { AuthModule } from './modules/auth';
import { WaybillModule } from './modules/thisWaybill';

Vue.use(Vuex);

/**
 * This interface exists so we can use the store state
 * within standard js components and not specific vuejs
 * components. Ideally we would update this to use
 * typescript correctly.
 */
interface State {
  app: any;
  auth: any;
  thisWaybill: any;
}

export default new Vuex.Store<any>({
  modules: {
    app: AppModule,
    auth: AuthModule,
    thisWaybill: WaybillModule,
  },
});
